import React from 'react';
import { Image } from 'react-bootstrap';

import './Snabbfakta.css'

const snabbfakta = props => (
  <div className="column-container">

    <div className="snabbfakta-image">
      <Image src="images/snabbfakta_liggande.jpg" responsive />
    </div>

    <div className="column-info">
      <h3> Snabbfakta </h3>

      <p> Sagan och musiken bygger och stärker relationer. Många vittnar om att barn visar mer respekt för varandra när de sjunger och läser om Vännerna i Kungaskogen.</p>

      <p> Ålder 3–9 år men vuxna älskar sagan lika mycket som barnen.</p>

      <p> Kungaparet har fått musiken från Kungaskogen framförd för sig personligen i ett specialuppträdande med barn inför Kungen och Drottning Silvia.</p>

      <p> Vännerna i Kungaskogen är värdegrundande med budskapen ”att vara schysst och en bra kompis”, empati och vi är olika men lika bra.</p>

      <p> Handling: Vänskap, att vara schysst och en bra kompis, vara rädd om naturen, livsstil, hälsa, miljö, hållbarhet.</p>

      <p> Börje Ahlstedt är berättare i den första boken.</p>

      <p> I bilderböckerna finns också CD-skivor <b>numera omgjorda till QR koder </b>och noter.</p>

      <p> Över 30 musiker och 15 skådespelare medverkar i de olika
        produktionerna.</p>

      <p> Vännerna i Kungaskogen spelas också som bioteater. Just nu är föreställningarna streamade och kan ses överallt t.ex. på en förskola. Förra året sågs föreställningarna av 20 000 barn.</p>

      <p> YouTube: Sökord "Kungaskogen" eller "Raffe räv" </p>

      <p> Spotify: Sökord "Kungaskogen" </p>

      <p> Instagram @kungaskogen </p>

      <p> Produkter: www.forskoleprodutker.se </p>

      <p> 34 originalsånger finns till Kungaskogen. Många är redan barnviseklassiker.</p>

      <p> Sagan och musiken om Kungaskogen är skriven för 2000-talets barn.</p>

      <p> Kungaskogen har stor potential att bli en skandinavisk barnklassiker.</p>

      <p> Kungaskogen är en av Sveriges största barnbokssatsning med musik.</p>

      <p> Kringprodukter har tagits fram kring sagan men det finns många fler möjligheter. Senaste produkter: Memo, Handdockor, Appar, Almanackstavla.</p>

      <p>Över 10000 förskolor i Sverige har Kungaskogen.</p>
      <p>Nära en miljon barn har mött sagofigurerna och musiken.</p>

      <p>Kompisarna i Kungaskogen är goda förebilder som
        barnen älskar och relaterar till i sin lek.</p>

      <p>Ca 800 000 föräldrar har mött Kungaskogen genom
        alla aktiviteter som gjorts/görs på förskola/skola med
        Kungaskogen. Stor privat efterfrågan.</p>

      <p>FÖRLAG: ILKA/Förlagshuset Wasa Malmö</p>

    </div>
  </div>
);

export default snabbfakta;
